(function($R) {
    $R.add('service', 'spdetector', {
        init: function(app) {
            this.app = app;

            // local
            this.platform = navigator.platform.toLowerCase();
        },
        isMac: function () {
            return this.platform.indexOf('mac') >= 0;
        },
        getShortcutKey: function () {
            return this.isMac() ? 'CMD' : 'CTRL';
        }
    });
})(Redactor);